import one from '../assets/png/WinSP_logo.png'
import two from '../assets/png/GP.png'
import three from '../assets/png/WF.png'
import four from '../assets/png/GameHive.png'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Windows Service Protector (WinSP)',
        projectDesc: 'A Windows security program developed in PowerShell that monitors services and detects background modifications of these Windows Services',
        tags: ['Powershell', 'Windows', 'CyberSecurity'],
        code: 'https://github.com/WillMcX/Windows-Services-Project-WinSP',
        demo: 'https://winsp.vercel.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'GPBundles',
        projectDesc: 'An e-commerce website for gaming accessories and peripherals, developed for IT310(E-Commerce)',
        tags: ['CMS', 'Web-Dev', "E-commerce"],
        code: 'https://wam328.wixsite.com/gpbundles',
        demo: 'https://wam328.wixsite.com/gpbundles',
        image: two
    },
     {
        id: 4,
        projectName: 'GameHive Remastered',
        projectDesc: 'A recreation of the enterprise level web development project for my Systems Integrations class in a new framework',
        tags: ['Javascript', 'Web-Dev'],
        code: 'https://gamehive-remastered.vercel.app/',
        demo: 'https://gamehive-remastered.vercel.app/',
        image: four
    },
    {
        id: 3,
        projectName: 'Willys Fruits',
        projectDesc: 'A fruit stand website that simulates the advertisement and sales of fruit in order to demonstrate basic HTML, CSS, PHP and JavaScript Knowledge, developed for IT202(Intro Web Dev)',
        tags: ['HTML/CSS', 'PHP', 'JavaScript'],
        code: 'https://web.njit.edu/~wam32/SemesterProject/home.php',
        demo: 'https://web.njit.edu/~wam32/SemesterProject/home.php',
        image: three
    },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/